import SectionHeading from "./SectionHeading";
import { watchSteps, watchTips } from "@/mocks/content";

export default function WatchGuide() {
  return (
    <section id="watch" className="scroll-mt-20 bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="Watch Guide"
          title="老片在线观看与回顾指引"
          desc="想系统看一遍老电影，先理清方向、片长与版本，会比随手点开更省时间。下面四步是一个可参考的顺序。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {watchSteps.map((step) => (
              <article
                key={step.step}
                className="rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${step.icon} text-xl`} />
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-300">
                    {step.step}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {step.desc}
                </p>
              </article>
            ))}
          </div>

          <div className="lg:col-span-5 flex flex-col gap-5">
            <div className="relative rounded-lg overflow-hidden min-h-[180px]">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20of%20an%20old%20film%20projector%20reel%20spinning%20with%20warm%20amber%20light%2C%20dust%20in%20the%20air%2C%20nostalgic%20vintage%20cinema%20equipment%2C%20artistic%20still%20life%20composition%2C%20deep%20warm%20tones%2C%20no%20text&width=800&height=600&seq=cinema-guide-projector-v1&orientation=landscape"
                alt="老式放映机与胶片盘，象征老片回顾"
                className="w-full h-full object-cover object-top absolute inset-0"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 to-primary-950/10" />
              <div className="relative p-5 flex flex-col justify-end h-full min-h-[180px]">
                <h3 className="font-heading text-lg font-semibold text-background-50">
                  观影小知识
                </h3>
                <p className="mt-1 text-xs text-background-200">
                  了解版本与配音，体验会更接近原貌
                </p>
              </div>
            </div>

            <ul className="rounded-lg border border-background-200 bg-background-50 p-5 space-y-3">
              {watchTips.map((tip) => (
                <li key={tip} className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg mt-0.5 shrink-0" />
                  <span className="text-sm leading-relaxed text-foreground-700">
                    {tip}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}